export default function HubSpotIcon({
  className,
}: React.ComponentProps<"svg">) {
  return (
    <img className={className} src="/images/integrations/hubspot.avif" alt="" />
  );
}
